import "./text-align-enum.mjs";
import "./utils/text-align.mjs";
import { useTextAlignExtensionToolbar as e } from "./use-text-align-extension-toolbar.mjs";
import { TextAlign as t } from "@tiptap/extension-text-align";
//#region src/extensions/text-align-extension/index.ts
var n = t.configure({
	types: [
		"heading",
		"paragraph",
		"listItem"
	],
	alignments: [
		"left",
		"center",
		"right",
		"justify"
	]
});
//#endregion
export { n as TextAlignExtension, e as useTextAlignExtensionToolbar };
